import React from 'react';
import { Helmet } from 'react-helmet';
import ProfileSettings from '../../components/ProfileSettings/ProfileSettings';
import './ProfilePage.css';

const ProfilePage = () => {
  return (
    <div className="profile-page">
      <Helmet>
        <title>Profile Settings | DASHBASKET</title>
      </Helmet>

      <div className="profile-page-container">
        <ProfileSettings />
      </div>
    </div>
  );
};

export default ProfilePage; 